var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.isSelected
      ? 'centers-region-button neumorphism-in'
      : 'centers-region-button neumorphism-out',on:{"click":function($event){return _vm.onClick(_vm.region)},"mouseover":function($event){return _vm.onMouseOver(_vm.region)},"mouseleave":function($event){return _vm.onMouseLeave(_vm.region)}}},[_c('span',{staticClass:"text-body-2"},[_vm._v(_vm._s(_vm.region.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }